<template>
  <div class="component-steps d-lg-block d-flex justify-content-between">
    <div
      v-for="(name, i) in names"
      :key="`mobile-${i}`"
      class="step mobile d-flex d-lg-none"
      :class="{
        past: step > i + 1,
        current: step === i + 1,
        last: i + 1 == names.length
      }"
      @click="$emit('change-step', i + 1)"
    >
      <div class="circle" :style="style(i)" role="button"></div>
    </div>
    <div
      v-for="(name, i) in names"
      :key="`desktop-${i}`"
      class="step desktop d-none d-lg-flex"
      :class="{ past: step > i + 1, current: step === i + 1 }"
      @click="$emit('change-step', i + 1)"
    >
      <div class="circle pr-6" :style="style(i)" role="button"></div>
      <div role="button" class="description d-lg-block d-none">
        {{ name }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    step: {
      type: Number,
      default: 1
    },
    names: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    style(i) {
      return '--step: "' + (i + 1) + '"';
    }
  }
};
</script>
<style lang="scss" scoped>
.component-steps {
  padding: 16px;
  @media screen and (max-width: 991px) {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .step {
    display: flex;
    color: #8d8799;
    transition: 0.3s all;

    &.mobile {
      align-items: center;
    }

    .divider {
      height: 2px;
      width: 27px;
      border-radius: 16px;
      background-color: #e0e1e6;
    }

    &:hover {
      color: #5a5466;
      .circle {
        &::after {
          box-shadow: 0px 4.99685px 6px rgba(0, 0, 0, 0.1),
            0px 8px 16px 8px rgba(0, 0, 0, 0.05);
        }
      }
    }
    &:active {
      color: #5a5466;
      .circle {
        &::after {
          box-shadow: 0px 16px 32px 12px rgba(0, 0, 0, 0.08),
            0px 4.99685px 14.9905px rgba(0, 0, 0, 0.15);
          outline: 1px solid #c09df5;
        }
      }
    }
    &:last-child {
      .circle {
        border-left: none;
        margin-left: 2px;
        padding-bottom: 0;
      }
    }
    .circle {
      position: relative;
      font-weight: 700;
      @media screen and (min-width: 992px) {
        padding-bottom: 64px;
        border-left: 2px solid #e0e1e6;
      }

      &::after {
        content: var(--step);

        @media screen and (min-width: 992px) {
          top: 0;
          position: absolute;
          transform: translateX(calc(-50% - 1px));
        }
        transition: 0.4s all;
        display: flex;
        align-items: center;
        justify-content: center;
        min-width: 24px;
        max-width: 24px;
        aspect-ratio: 1;
        font-size: 13px;
        color: #6d8af3;
        border-radius: 50%;
        background-color: white;
        border: 1px solid #b2c1f5;
        outline: 1px solid transparent;
      }
    }
    &.current {
      color: #2d50cd;
      .circle {
        &::after {
          border: 1px solid #5576ec;
        }
      }
      &:hover,
      &:active {
        color: #4c1a97;
      }
      &:active {
        .circle {
          &::after {
            outline: 1px solid #5576ec;
          }
        }
      }
    }
    &.past {
      color: #b888ffdb;
      .circle {
        @media screen and (min-width: 992px) {
          border-left: 2px solid #5576ec;
        }
        &::after {
          color: white;
          background: #5576ec;
          border: 1px solid #2d50cd;
        }
      }
      &:hover,
      &:active {
        color: #5576ec;
      }
      &:active {
        .circle {
          &::after {
            outline: 1px solid #2d50cd;
          }
        }
      }
    }

    @media screen and (max-width: 991px) {
      display: block;
      flex: 1;
      .circle {
        padding: 0;
        width: 100%;
        border-left: none;
        border-top: 2px solid #e0e1e6;
        &::after {
          transform: translateY(calc(-50% - 1px));
        }
      }
      &:last-child {
        display: flex;
        flex: none;
        .circle {
          border-top: none;
          margin-top: 2px;
          padding-bottom: 0;
        }
      }
      &.past {
        .circle {
          border-left: unset;
          border-top: 2px solid #5576ec;
        }
      }
      &.current {
        color: #2d50cd;
        .circle {
          &::after {
            top: unset;
          }
        }
      }

      &.last {
        flex: 0;
        .circle {
          border-top: none;
          &::after {
            top: unset;
          }
        }
      }
    }
  }
}
</style>
